import styled from 'styled-components'

export const FailureContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 50px;
`

export const FailureImg = styled.img`
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
`

export const FailureHeading = styled.h1`
  font-size: 40px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'Roboto';
  font-weight: bold;
  color: ${props => (props.theme === true ? '#ffffff' : '#313131')};
`
export const FailurePara = styled.p`
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'Roboto';
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
`
export const FailureButton = styled.button`
  height: 42px;
  width: 120px;
  color: #fffffff;
  background-color: #3b82f6;
  border: none;
  border-radius: 8px;
  text-align: center;
  outline: none;
  cursor: pointer;
`
